<template>
    <div class="enps-ranking">
        <EnpsTableToolbar
            placeholder="Поиск по ФИО"
            with-inactive-filter
            :hide-inactive="hideInactive"
            :visible-count="filteredRows.length"
            :total-count="ranking.rated.length"
            @input="searchQuery = $event"
            @toggle-inactive="hideInactive = $event"
        ></EnpsTableToolbar>

        <div class="enps-ranking__row enps-ranking__row_header">
            <span class="enps-ranking__name">Исполнитель</span>
            <span class="enps-ranking__rating">Средняя оценка</span>
            <span class="enps-ranking__count">Оценок</span>
            <span class="enps-ranking__count">Закрыто</span>
            <span class="enps-ranking__distribution">Распределение</span>
        </div>

        <div
            v-for="executor in filteredRows"
            :key="executor.accountId"
            class="enps-ranking__row"
            :class="{ 'enps-ranking__row_selected': selectedId === executor.accountId }"
            @click="$emit('select-executor', executor)"
        >
            <!-- В рейтинг попадают и те, кого деактивировали или у кого сняли роль исполнителя
                 (их оценки за период никуда не деваются) — пометка объясняет незнакомую фамилию. -->
            <span class="enps-ranking__name" :class="{ 'enps-ranking__name_disabled': !executor.enabled }">
                {{ executor.displayName }}
                <span v-if="!executor.enabled" class="enps-ranking__badge" title="Аккаунт отключён">неактивен</span>
            </span>
            <span class="enps-ranking__rating">{{ executor.averageRating }}</span>
            <span class="enps-ranking__count">{{ executor.ratingsCount }}</span>
            <!-- Нагрузка: 4.9 у человека с 5 закрытыми обращениями и с 200 — разные 4.9. -->
            <span class="enps-ranking__count">{{ executor.closedCount }}</span>
            <span class="enps-ranking__distribution">
                <EnpsRatingDistributionBar :distribution="executor.ratingDistribution"></EnpsRatingDistributionBar>
            </span>
        </div>

        <div v-if="ranking.rated.length === 0" class="enps-ranking__empty">Нет оценок за период</div>
        <div v-else-if="filteredRows.length === 0" class="enps-ranking__empty">По запросу ничего не найдено</div>
    </div>
</template>
<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import EnpsRatingDistributionBar from './EnpsRatingDistributionBar.vue';
import EnpsTableToolbar from '@/views/components/EnpsTableToolbar.vue';
import { matchesQuery } from '@/js/textSearch';

@Component({
    components: {
        EnpsRatingDistributionBar,
        EnpsTableToolbar,
    },
})
class EnpsRankingTable extends Vue {
    // Исполнители без оценок за период не рендерятся — ни отдельным блоком, ни серыми
    // строками: бэкенд их и не присылает (см. комментарий у ростера в getSummary()).
    @Prop({ type: Object, default: () => ({ rated: [] }) })
    ranking;

    // Кто открыт в панели справа — строка подсвечивается, чтобы при последовательном разборе
    // было видно, чью карточку сейчас смотришь.
    @Prop({ type: Number, default: null })
    selectedId;

    // Поиск/фильтр — состояние самой таблицы, не Vuex и не пропы: это чисто отображаемый срез
    // уже загруженных данных, менять состав ranking.rated в сторе из-за него не нужно.
    searchQuery = '';
    hideInactive = false;

    // ВАЖНО: фильтрация только скрывает строки и НИЧЕГО не делает с selectedId — он приходит
    // пропом от EnpsDashboardPage и меняется исключительно кликом пользователя. Если бы поиск
    // сбрасывал/переключал выбор, EnpsRatingsPanel перегружала бы карточку на каждое нажатие
    // клавиши (см. @Watch на subject в этой панели) — то есть лишние запросы к серверу на ввод
    // текста, чего быть не должно.
    get filteredRows() {
        return this.ranking.rated.filter((executor) => {
            if (this.hideInactive && !executor.enabled) {
                return false;
            }

            return matchesQuery(executor.displayName, this.searchQuery);
        });
    }
}

export default EnpsRankingTable;
</script>
<style lang="scss">
.enps-ranking {
    margin-bottom: 20px;

    &__row {
        display: flex;
        padding: 10px 15px;
        cursor: pointer;
        border-bottom: 1px solid #e4eaef;

        &:hover {
            background-color: #f8f8f8;
        }

        // Полутон акцента (ACCENT_TINT из enpsColors.js).
        &_selected,
        &_selected:hover {
            background-color: #fdeadd;
        }

        &_header {
            font-weight: 600;
            cursor: default;

            &:hover {
                background-color: transparent;
            }
        }
    }

    &__name {
        flex: 1;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        &_disabled {
            color: #767676;
        }
    }

    &__badge {
        margin-left: 6px;
        color: #a0a0a0;
        font-size: 0.75rem;
    }

    &__rating {
        width: 120px;
        text-align: right;
        flex-shrink: 0;
    }

    &__count {
        width: 80px;
        text-align: right;
        flex-shrink: 0;
    }

    &__distribution {
        display: flex;
        width: 120px;
        justify-content: flex-end;
        flex-shrink: 0;
    }

    &__empty {
        padding: 20px 15px;
        text-align: center;
        color: #a0a0a0;
    }
}
</style>
